import React, { useState } from 'react';
import * as NoteUI from '../NoteUI';
import { IconWrapper, SvgIcon } from '../../../../Icon';
import NoteActions from '../NoteActions';
import { useNavigate } from 'react-router-dom';
import { getCohortPagePath } from '../../../../../utils';
import {
  DraggableAttributes,
  DraggableSyntheticListeners,
} from '@dnd-kit/core';
import { ICohortNoteFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';

interface ICohortNoteProps {
  noteId: string;
  content: ICohortNoteFieldsFragment;
  dragHandleProps?: {
    attributes: DraggableAttributes;
    listeners?: DraggableSyntheticListeners;
  };
}

const CohortNote = ({ noteId, content, dragHandleProps }: ICohortNoteProps) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    navigate(getCohortPagePath(content.cohort.id));
  };

  return (
    <NoteUI.Container>
      <NoteUI.Header
        onMouseOver={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <NoteUI.Row>
          <IconWrapper size={16}>
            {isHovered && dragHandleProps && (
              <NoteUI.DragHandle
                name="drag-drop"
                width={12}
                height={12}
                {...dragHandleProps.attributes}
                {...dragHandleProps.listeners}
              />
            )}
            {!isHovered && (
              <SvgIcon name="users-three" width={16} height={16} />
            )}
          </IconWrapper>
          <NoteUI.Name onClick={handleClick}>Cohort</NoteUI.Name>
        </NoteUI.Row>
        <NoteActions noteId={noteId} />
      </NoteUI.Header>
      <NoteUI.Content>
        <NoteUI.Title>{content.cohort.name}</NoteUI.Title>
        <NoteUI.Description>
          {content.cohort.version?.description}
        </NoteUI.Description>
      </NoteUI.Content>
    </NoteUI.Container>
  );
};

export default CohortNote;
